import { lazy, memo, Suspense } from "react";
import "../css/Vision.css";

const CommonVideoPlayer = lazy(() => import("../common/common-video-player"));
const Banner = lazy(() => import("../Banner"));

const BANNER_STYLE = { backgroundImage: "url('/Vision-Landing.png')" };
const FALLBACK_STYLE = { minHeight: 200 };
const IMG_ASPECT_WIDTH = 800;
const IMG_ASPECT_HEIGHT = 600;

const POINTS = [
  "To economically empower the Muslim Ummah through trade.",
  "To revive the Sunnah of our Prophet ﷺ of Muslims working together through mutually beneficial relationships and networking.",
  "To promote the Islamic and ethical way of work and trade, so Muslims are positive role models in their business and professional lives.",
  "To develop local Muslim Business Ecosystems that are a part of a wider global network, as a unified non-sectarian non-political voice for the Muslim Business Community.",
];

const SUPPORT_POINTS = [
  "Businesses with reliable B2B services, sourcing investment, and starting new businesses",
  "Professionals with career mentorship, employment opportunities and investment opportunities.",
  "Corporate organisations with international expansion and partnerships.",
];

function VisionInner() {
  return (
    <div className="w-100">
      <div
        className="vision-banner d-flex w-100 justify-content-center align-items-center"
        style={BANNER_STYLE}
      >
        <h1>Our Vision</h1>
      </div>
      <div className="container py-4">
        <div className="row gap-4 gap-md-0">
          <div className="col-md-6">
            <h1>We Create Networks to Empower & Inspire Muslims Globally</h1>
            <h2 className="mb-4">Our Vision</h2>
            <ul className="list-disc pl-5 space-y-2">
              {POINTS.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </div>
          <div className="col-md-6 d-flex justify-content-center align-items-center">
            <Suspense fallback={<div style={FALLBACK_STYLE} aria-hidden="true" />}>
              <CommonVideoPlayer
                backgroundImage="url(SMBF.png)"
                src="video.mp4"
              />
            </Suspense>
          </div>
        </div>
      </div>
      <div className="secondary-bg">
        <div className="container secondary-bg py-4">
          <div className="row gap-4 gap-md-0">
            <div className="col-md-5 d-flex justify-content-center align-items-center">
              <img
                className="img-fluid w-100 image h-100 rounded-4"
                src="/SMBF-17.png"
                alt="Islamic history and heritage"
                width={IMG_ASPECT_WIDTH}
                height={IMG_ASPECT_HEIGHT}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="col-md-7 d-flex justify-content-center flex-column">
              <h1>Islamic History</h1>
              <p>
                The Messenger of Allah ﷺ said: ‘Engage in business, for 9/10th
                of blessings is found in it.’
              </p>

              <p>
                Support Muslim Business Forum is an exclusive membership network
                for Muslim professionals and businesses that was established by
                the world-renowned Islamic Research scholar and businessman,
                Mufti Qazi Hassan Razza.
              </p>
              <p>
                The Messenger of Allah ﷺ organised a network of highly skilled
                and professional businessmen and women. This would go on to form
                the foundation for the economic empowerment and growth of Islam.
                At SMBF, we aim to revive this Sunnah and see Muslims working
                with each other as our Prophet ﷺ did before us.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="container py-4">
        <div className="row">
          <div className="col-md-7 d-flex justify-content-center flex-column">
            <p>
              When the Messenger of Allah ﷺ migrated to Madinah, he paired his
              migrant companions who were merchants by profession, with the
              helpers of Madinah who were farmers. He then established a
              separate Muslim market which was the world’s first tax-free zone.
              This was the basis for the expansion of the fastest-growing empire
              to ever exist, where the Messenger of Allahﷺ honed the skill sets
              of different individuals, teaching them to work together to
              benefit themselves and humankind.
            </p>
            <p>
              The Messenger of Allah ﷺ said: ‘The honest and trustworthy
              businessperson will be with the Prophets, the truthful and the
              martyrs.’
            </p>
          </div>
          <div className="col-md-5 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid w-100 image h-100 rounded-4"
              src="/SMBF-18.png"
              alt="Muslim market and trade heritage"
              width={IMG_ASPECT_WIDTH}
              height={IMG_ASPECT_HEIGHT}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
      <div className="secondary-bg">
        <div className="container py-4">
          <div className="row gap-4 gap-md-0">
            <div className="col-md-5 d-flex justify-content-center align-items-center">
              <img
                className="img-fluid w-100 image h-100 rounded-4"
                src="/SMBF-19.png"
                alt="Early Muslim companions and trade"
                width={IMG_ASPECT_WIDTH}
                height={IMG_ASPECT_HEIGHT}
                loading="lazy"
                decoding="async"
              />
            </div>
            <div className="col-md-7 d-flex justify-content-center flex-column">
              <p>
                From this Hadith, we understand that while the Martyrs protect
                the borders of Islam, the business and professional community
                strengthens it from within. The first 300 years of Islam’s
                growth were through business activities and many of the early
                male and female companions were successful businesspeople,
                including
              </p>

              <p>
                Khadija Bint Khuwaylid, whose wealth was greater than all of the
                Quraysh combined. Uthmaan Ibn Affan, who was a wholesale textile
                dealer Abdur Rahman ibn Auf, had a wholesale food business. Asma
                Bint Abu Bakr, owned a farm and fed the companions from her
                produce on Jummah.
              </p>
              <p>
                There are also many other companions who were highly skilled in
                various fields; may Allah be pleased with them all. SMBF
                operates by this principle from early Islam, that worldly
                success and finance are a means for success in the hereafter, if
                we work together for Islam, as opposed to worldly success being
                a barrier to our spiritual growth, which is a common
                misconception.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="gradient-bg py-4 text-center d-flex align-items-center justify-content-center fs-3 px-5 text-white">
        <h1 className="px-md-5">
          This is because this world is a harvesting ground for the hereafter.
        </h1>
      </div>

      <div className="m-4 support-container border p-4 p-md-5 rounded-4">
        <div className="row gap-4 gap-md-0">
          <div className="col-md-7">
            <h2>What We Do</h2>
            <p className="mb-4">
              The Messenger of Allah ﷺ said : ‘There are three (things) by which
              a believer will not be deceived; sincerity in deeds for Allah,
              good will to the Muslims and keeping to their community.’
            </p>
            <p>
              SMBF fosters mutually beneficial relationships between Muslim
              professionals, businesses and corporate organisations, encouraging
              trade based on Islamic & ethical principles.
            </p>
            <h5>We support</h5>
            <ul className="list-disc pl-5 space-y-2">
              {SUPPORT_POINTS.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </div>
          <div className="col-md-5 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid w-100 image h-100 rounded-4"
              src="/SMBF-20.png"
              alt="What we do – community and trade"
              width={IMG_ASPECT_WIDTH}
              height={IMG_ASPECT_HEIGHT}
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
      <div className="container py-4">
        <div className="row gap-4 gap-md-0">
          <div className="col-md-5 d-flex justify-content-center align-items-center">
            <img
              className="img-fluid w-100 image h-100 rounded-4"
              src="/SMBF-21.png"
              alt="Our founder Mufti Qazi Hassan Razza"
              width={IMG_ASPECT_WIDTH}
              height={IMG_ASPECT_HEIGHT}
              loading="lazy"
              decoding="async"
            />
          </div>
          <div className="col-md-7 d-flex justify-content-center flex-column">
            <h2>Our Founder</h2>
            <p>
              Our founder Mufti Qazi Hassan Razza is a world-renowned Islamic
              research scholar, consultant and businessman based in West
              Yorkshire. The Shaykh is recognised as one of the most senior
              scholars in Islamic Jurisprudence, Qur’anic exegesis, Hadith,
              Arabic grammar, and Islamic Spirituality. He has established over
              one hundred Islamic educational institutes across the world. He is
              also a published author, with a catalogue of works on various
              topics in Arabic, English, Persian and Urdu.
            </p>
            <p>
              The Shaykh has trained hundreds of scholars from across the world,
              with a particular focus on the education of women. His UK based
              institutes alone produce over 100 scholars on an annual basis.
              Alongside this, the Shaykh has established a global charity known
              as Save the Mother’s Trust (SMT) in 2003, with the purpose of
              aiding self-sufficiency in the third world, providing aid in areas
              overlooked by mainstream media coverage. Despite his significant
              contributions in the fields of education, Islamic literature and
              Philanthropy, the Shaykh founded SMBF in 2011, with the aim of
              uniting the Muslim business and professional community on one
              platform, to make a positive contribution globally, by the will of
              Allah.
            </p>
          </div>
        </div>
      </div>
      <Suspense fallback={<div style={FALLBACK_STYLE} aria-hidden="true" />}>
        <Banner />
      </Suspense>
    </div>
  );
}

VisionInner.displayName = "Vision";

export default memo(VisionInner);
